export function canAccess(user, permission) {
  if (!user) {
    return false;
  }

  if (user.isOrgAdmin || user.isPlatformAdmin) {
    return true;
  }

  return Array.isArray(user.permissions) && user.permissions.includes(permission);
}

export function canAccessAny(user, permissions) {
  return permissions.some((permission) => canAccess(user, permission));
}

export const NAV_PERMISSIONS = {
  '/': null,
  '/companies': 'companies.read',
  '/projects': 'projects.read',
  '/general-tasks': 'generalTasks.read',
  '/personnel': 'personnel.read',
  '/due-dates': ['personnel.read', 'materials.read', 'projects.read', 'finance.quotes.read', 'finance.invoices.read', 'finance.deliveries.read'],
  '/tools': 'tools.read',
  '/warehouse': ['warehouse.read', 'tools.read', 'materials.read'],
  '/materials': 'warehouse.read',
  '/site-delivery': 'siteLogistics.read',
  '/site-departure': 'siteLogistics.read',
  '/cost-sheets': 'costSheets.read',
  '/daily-work-input': 'dailyWork.read',
  '/daily-work-cost-sheet-mapping': 'dailyWorkCostSheetMapping.read',
  '/worker-hours-report': 'workerHoursReport.read',
  '/my-hours': 'myHours.read',
  '/work-quantities': 'costSheets.read',
  '/project-expenses': 'costSheets.read',
  '/project-timelines': 'projects.read',
  '/write-offs': 'writeOffs.read',
  '/users': ['org.users.manage', 'org.users.remove'],
  '/account': null,
  '/finance': ['finance.quotes.read', 'finance.deliveries.read', 'finance.invoices.read'],
  '/finance/quotes': 'finance.quotes.read',
  '/finance/deliveries': 'finance.deliveries.read',
  '/finance/invoices': 'finance.invoices.read',
  '/finance/settings': ['finance.quotes.write', 'finance.invoices.write'],
};
